// extracted by mini-css-extract-plugin
module.exports = {"reportState":"styles_reportState__2OOgU","reportType":"styles_reportType__2RGaE"};